// Uygulama sürüm bilgileri
// Bu dosya her build'de otomatik güncellenir

// Vite'den environment değişkenlerini al (varsa)
const viteVersion = import.meta.env.VITE_APP_VERSION;
const viteBuildNumber = import.meta.env.VITE_BUILD_NUMBER;

// package.json'den versiyonu al
import packageJson from '../../package.json';

export const APP_VERSION = viteVersion || packageJson.version || '1.0.0';
export const BUILD_NUMBER = '1.3.40';
export const BUILD_DATE = new Date().toISOString().split('T')[0];
export const BUILD_TIMESTAMP = new Date().toISOString();
